<template>
  <l-fixed-window>
    <v-tabs grow slot="fixed-top" v-model="tabs">
      <v-tab href="#sendSmsMessage">发送短信</v-tab>
      <v-tab href="#sendWechatMessage">发送微信</v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <div>
      <v-tabs-items v-model="tabs">
        <v-tab-item :value="'sendSmsMessage'">
          <sms-message-list></sms-message-list>
        </v-tab-item>
        <v-tab-item :value="'sendWechatMessage'" >
          <wechat-message-list></wechat-message-list>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </l-fixed-window>
</template>
<script>
import smsMessageList from './smsMessageList'
import wechatMessageList from './wechatMessageList'
export default {
  name: 'sendMessage',
  components: {
    smsMessageList,
    wechatMessageList
  },
  data () {
    return {
      tabs: null
    }
  }
}
</script>
